import { cn } from "@/lib/utils"

import { Spinner } from "../../Spinner"
import { LE_TableInstance } from "../types"
import { Pagination } from "./Pagination"

export function Footer<T extends Record<string, any> = object>({
  table,
  className,
}: {
  table: LE_TableInstance<T>
  className?: string
}) {
  const { total, isLoading } = table.getState()

  return (
    <span
      className={cn(
        "flex shrink-0 items-center justify-between gap-4 overflow-auto border-t border-solid border-border bg-background px-5 py-3 text-body1",
        className,
      )}
    >
      <div>{isLoading && <Spinner />}</div>
      {table.enablePagination ? (
        <Pagination table={table} />
      ) : (
        <span className="text-muted-foreground">{total} rows</span>
      )}
    </span>
  )
}
